jQuery.event.special.touchstart = {
  setup: function( _, ns, handle ) {
    this.addEventListener("click touchstart", handle, { passive: !ns.includes("noPreventDefault") });
  }
};

jQuery.event.special.touchmove = {
  setup: function( _, ns, handle ) {
    this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
  }
};

jQuery.event.special.wheel = {
  setup: function( _, ns, handle ){
    this.addEventListener("wheel", handle, { passive: true });
  }
};

jQuery.event.special.mousewheel = {
  setup: function( _, ns, handle ){
    this.addEventListener("mousewheel", handle, { passive: true });
  }
};

toggle = $('.js-menu-toggle');
menu = $('.js-menu');
header = $('.header');
collapse = $('.menu-item-has-children');
// searchToggle = $('.js-search-toggle');
// resourcesSearchToggle = $('.js-library-search-toggle');
resourcesSearchToggle = $('.resources-search-toggle');
resourcesTopicsToggle = $('.resources-topics-toggle');
shareToggle = $('.share-toggle');

function showNav() {
  menu.addClass('nav-open');
  $('body').addClass('nav-open');
  window.setTimeout(function () {
    $('body').addClass('no_scroll');
  }, 200); // Firefox hack. Hides scrollbar as soon as menu animation is done
  $('.nav--main a').attr('tabindex', ''); // links inside navigation should be TAB selectable
}

function hideNav() {
  menu.removeClass('nav-open');
  $('body').removeClass('nav-open');
  window.setTimeout(function () {
    $('body').removeClass('no_scroll');
  }, 10); // allow animations to start before removing class (Firefox)
  $('.nav--main a').attr('tabindex', '-1'); // links inside hidden navigation should not be TAB selectable

  // $(".nav--main > .menu-item-has-children:not(.wpml-ls-menu-item)").attr("aria-expanded", "false");
  // $(".nav--main > .menu-item-has-children:not(.wpml-ls-menu-item)").removeClass("menu-item-has-children--open");
}

function showHideNav() {
  if ($('.js-menu').hasClass('nav-open')) {
    hideNav();
  } else {
    showNav();
  }
}

// Dropdown functionality
$('.menu-item-has-children > a').click(function () {
  $(this).parent().toggleClass('collapsed');
});
// $('.nav--main > .menu-item-has-children.wpml-ls-menu-item > a').click(function () {
//   $(this).parent().toggleClass('collapsed');
// });

$(".nav--main > .menu-item-has-children:not(.wpml-ls-menu-item) > a:not(:only-child)").click(function (event) {
  if ($(this).parent().attr("aria-expanded") == "true" && $(this).parent().hasClass("menu-item-has-children--open")) {
    $(this).parent().attr("aria-expanded", "false");
    $(this).parent().removeClass("menu-item-has-children--open");
  } else {
    $(this).parent().attr("aria-expanded", "true");
    $(this).parent().addClass("menu-item-has-children--open");
  }
});

$(".nav--main > .menu-item-has-children:not(.wpml-ls-menu-item) .submenu .submenu__parent").on('click', function (event) {
  if ($(this).parent().parent().parent().attr("aria-expanded") == "true" && $(this).parent().parent().parent().hasClass("menu-item-has-children--open")) {
    $(this).parent().parent().parent().attr("aria-expanded", "false");
    $(this).parent().parent().parent().removeClass("menu-item-has-children--open");
  }
});

// Shows/hides navigation’s popover if class "expanded"
toggle.on('click touchstart', function (event) {
  showHideNav();
  event.preventDefault();
});

// // Search
// searchToggle.on('click touchstart', function (event) {
//   $('.search-box').toggleClass('visible');
//   event.preventDefault();
// });

// searchLibraryToggle.on('click touchstart', function (event) {
//   event.preventDefault();
//   $('.library-search').fadeIn(200);
//   $('.library-search').addClass('search-open');
//   $('.library-search #searchform #s').focus();
// });

// $('body').keydown(function (e) {
//   // menu accessible via TAB as well
//   if (toggle.is(':focus')) {
//     // if ENTER/SPACE show/hide menu
//     if (e.keyCode === 13 || e.keyCode === 32) {
//       showHideNav();
//       e.preventDefault();
//     }
//   }
// });

// $(document).keydown(function (event) {
//   if (event.keyCode == 27) {
//     if ($('.library-search').hasClass('search-open')) {
//       $('.library-search').fadeOut(200);
//       $('.library-search').removeClass('search-open');
//       searchLibraryToggle.focus();
//     }
//   }
// });

// $(document).on('click touchstart', function (event) {
//   if (
//     !$(event.target).closest('.library-search').length &&
//     !$(event.target).is('.library-search') &&
//     !$(event.target).is('.js-library-search-toggle') &&
//     !$(event.target).is('.js-library-search-toggle *') &&
//     !$(event.target).is('.tease-post') &&
//     !$(event.target).is('.tease-post *') &&
//     !$(event.target).is('.wisepops-root *')
//   ) {
//     $('.library-search').fadeOut(200);
//     $('.library-search').removeClass('search-open');
//     searchLibraryToggle.focus();
//   }
// });

$('.menu-item-has-children a').click(function (event) {
  event.stopPropagation();
});

$('.menu-item-has-children > a').click(function (event) {
  event.preventDefault();
});

/*** Mobile Navigation ***/

$(".mobile-menu-toggle").click(function (e) {
  e.preventDefault();
  $(this).toggleClass("collapsed");
  $(".nav--library").toggleClass("collapsed");
});

/*** Modal ***/

function hideModals() {
	// $("main").attr("aria-hidden", "false");
	$(".modal").fadeOut(200);
	$(".modal").attr("aria-hidden", "true");
	$(".modal").removeClass("modal--open");
	$(".modal").removeClass("keyboard-init");
	window.setTimeout(function () { $('body').removeClass('no-scroll'); }, 10);

  if (shareToggle.hasClass("share-toggle--active")) {
    shareToggle.removeClass("share-toggle--active");
    shareToggle.find(".share-toggle__y").css("height", "100%");
  }
}

resourcesSearchToggle.on('click touchstart', function (event) {
	event.preventDefault();
	// $("main").attr("aria-hidden", "true");
	$(".modal--resources-search").fadeIn(200);
	$(".modal--resources-search").attr("aria-hidden", "false");
	$(".modal--resources-search").addClass("modal--open");

	window.setTimeout(function () { 
		$('body').addClass('no-scroll'); 
	}, 200);
});

resourcesSearchToggle.keydown(function(event) {
	if (event.keyCode == 13) {
		$(".modal--resources-search").addClass("keyboard-init");
	}
});

shareToggle.on('click touchstart', function (event) {
	// $("main").attr("aria-hidden", "true");
	$(".modal--share").fadeIn(200);
	$(".modal--share").attr("aria-hidden", "false");
	$(".modal--share").addClass("modal--open");

	window.setTimeout(function () { 
		$('body').addClass('no-scroll'); 
	}, 200);

  if ($(this).hasClass("share-toggle--active")) {
    $(this).removeClass("share-toggle--active");
    $(this).find(".share-toggle__y").css("height", "100%");
  } else {
    $(this).addClass("share-toggle--active");
    $(this).find(".share-toggle__y").css("height", "0%");
  }
});

shareToggle.keydown(function(event) {
	if (event.keyCode == 13) {
		$(".modal--share").addClass("keyboard-init");
	}
});

$(".modal__close").on("click touchstart", function(event) {
	event.preventDefault();
	hideModals();
});

$(document).keydown(function(event) { 
	if (event.keyCode == 27) { 
		if ($(".modal").hasClass("modal--open")) {
			hideModals();
		}
	}
});

resourcesTopicsToggle.on('click touchstart', function (event) {
  if ($(this).hasClass("resources-topics-toggle--active")) {
    $(this).next(".resources-topics-dropdown").fadeOut(200);
    $(this).next(".resources-topics-dropdown").attr("aria-hidden", "true");
    $(this).removeClass("resources-topics-toggle--active");
    $(this).removeClass("keyboard-init");
    $(this).find(".resources-topics-toggle__y").css("height", "100%");
  } else {
    $(this).next(".resources-topics-dropdown").fadeIn(200);
    $(this).next(".resources-topics-dropdown").attr("aria-hidden", "false");
    $(this).addClass("resources-topics-toggle--active");
    $(this).find(".resources-topics-toggle__y").css("height", "0%");
  }
  event.stopPropagation();
});

resourcesTopicsToggle.keydown(function(event) {
  if (event.keyCode == 13) {
    $(this).next(".resources-topics-dropdown").addClass("keyboard-init");
  }
});

/*** HTML ***/

$("html").on('click', function() {
  if (resourcesTopicsToggle.hasClass("resources-topics-toggle--active")) {
    resourcesTopicsToggle.next(".resources-topics-dropdown").fadeOut(200);
    resourcesTopicsToggle.next(".resources-topics-dropdown").attr("aria-hidden", "true");
    resourcesTopicsToggle.removeClass("resources-topics-toggle--active");
    resourcesTopicsToggle.removeClass("keyboard-init");
    resourcesTopicsToggle.find(".resources-topics-toggle__y").css("height", "100%");
  }
});